import React from 'react'
import { useContext } from './Context'
import { BusyButton } from '@ztechapps/webui.button'

export const AddButton = () => {
  const { onAdd } = useContext()
  return <BusyButton onClick={onAdd} title="Add new" icon="plus" />
}
